import { Actions, Channel, MyAccountTab, Topic } from "../../../../constants";
import { MessageBrokerUtils, NavigationUtils } from "../../../../utils";

export const action = isAuthenticated => {
  if (isAuthenticated) {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.CTA_MyAccount_Open,
      headers: { publisher: "unifiedclient" },
      data: { tabId: MyAccountTab.RewardsPWC }
    });
  } else {
    const data = {
      actionID: Actions.openMyAccount,
      actionData: { tabId: MyAccountTab.RewardsPWC }
    };
    NavigationUtils.runFlowRunner(data);
  }
};

export const alwaysEnabled = true;
